import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";

export const TextSchema: RegistryItem = {
	[AgreementTypeEnum.Text]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Manual,
			},
		},
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
			"agreement.invoiceTo": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
		isNotDeclarable: true,
	},
};
